// extracted by mini-css-extract-plugin
module.exports = {"TodoBuilder":"TodoBuilder_TodoBuilder__1i5us"};